import { Routes } from '@angular/router';
import { AuthGuard } from './shared/foundry-guard/keycloak-auth.guard';

/** Published screen URLs are resolved from JSON, without per-screen route declarations. */
export const routes: Routes = [
  { path: '', redirectTo: 'home-main', pathMatch: 'full' },
  { path: 'session-expired', loadComponent: () => import('./modules/session-expired/session-expired.component').then(m => m.SessionExpiredComponent) },
  { path: 'design-builder', canActivate: [AuthGuard], data: { accessKey: 'design-builder' }, loadComponent: () => import('./modules/design-builder/design-builder-screen.component').then(m => m.DesignBuilderScreenComponent) },
  { path: ':screenSlug', canActivate: [AuthGuard], runGuardsAndResolvers: 'paramsOrQueryParamsChange', loadComponent: () => import('./screen-renderer/published/published-screen.component').then(m => m.PublishedScreenComponent) },
  { path: '**', redirectTo: 'home-main' },
];
